import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import type { Listing } from "@b2bportal/homes-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { BedTypeEnum } from "@hopper-b2b/types";
import { HotelShopSection } from "@tenant/hotels";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import styles from "./RoomsAndBeds.module.scss";

const ROOMS_ICON_MAP = {
  [BedTypeEnum.Single]: IconNameEnum.stays__bedSingle,
  [BedTypeEnum.Double]: IconNameEnum.bed,
  [BedTypeEnum.Queen]: IconNameEnum.bed,
  [BedTypeEnum.King]: IconNameEnum.bed,
  [BedTypeEnum.Twin]: IconNameEnum.bed,
  [BedTypeEnum.Murphy]: IconNameEnum.stays__bedOther,
  [BedTypeEnum.RunOfTheHouse]: IconNameEnum.stays__bedOther,
  [BedTypeEnum.Dorm]: IconNameEnum.stays__bedOther,
  [BedTypeEnum.Water]: IconNameEnum.bed,
  [BedTypeEnum.Sofa]: IconNameEnum.stays__sofa,
  [BedTypeEnum.Full]: IconNameEnum.bed,
  [BedTypeEnum.Tatami]: IconNameEnum.stays__bedOther,
  [BedTypeEnum.Futon]: IconNameEnum.stays__bedOther,
};

export const RoomsAndBeds = ({
  listing,
  className,
}: { listing: Listing } & PlatformComponentProps) => {
  const { layout } = listing.content;
  const { bedrooms, bathrooms } = layout;
  const [block, cn] = useModuleBEM(styles, "RoomsAndBeds");
  const { t } = useI18nContext();
  return (
    <HotelShopSection className={clsx(block, className)}>
      <p className={cn("title")}>{t("core-hotels.homes.roomsAndBeds.title")}</p>
      <div className={cn("container")}>
        {bedrooms.map((bedroom, index) => (
          <div className={cn("tile")} key={index}>
            <Icon
              className={cn("tile-icon")}
              iconName={
                //TODO(Danii): double check the response here
                ROOMS_ICON_MAP[bedroom.bedTypes[0]?.name] ?? IconNameEnum.bed
              }
            />
            <p className={cn("tile-title")}>
              {t("core-hotels.homes.roomsAndBeds.bedroomTitle", {
                index: index + 1,
              })}
            </p>
            <p className={cn("tile-description")}>{bedroom.description}</p>
          </div>
        ))}
        {bathrooms.map((bathroom, index) => (
          <div className={cn("tile")}>
            <Icon
              className={cn("tile-icon")}
              iconName={IconNameEnum.stays__bathroom}
            />
            <p className={cn("tile-title")}>
              {t("core-hotels.homes.roomsAndBeds.bathroomTitle", {
                index: index + 1,
              })}
            </p>
            <p className={cn("tile-description")}>{bathroom.description}</p>
          </div>
        ))}
      </div>
    </HotelShopSection>
  );
};
